export default __webpack_public_path__ + "static/media/logo.5d77c8f5.png";